module.exports = __webpack_public_path__ + "static/media/process-img2.8154d1ac.webp";